import { useState } from 'react';
import { Button } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import { ConfirmDialog } from '../ConfirmDialog';

interface Props {
  loading: boolean;
  disabled?: boolean;
  onConfirm: () => void;
}

export function ResetFromTemplateButton({ loading, disabled, onConfirm }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<RestoreIcon />}
        onClick={() => setOpen(true)}
        disabled={disabled || loading}
      >
        Reset na šablonu
      </Button>
      <ConfirmDialog
        open={open}
        title="Resetovat startovací skupiny?"
        message="Všechny existující startovací skupiny pro tuto disciplínu budou smazány a nahrazeny výchozími hodnotami ze šablony soutěže. Pokračovat?"
        confirmText="Resetovat"
        destructive
        loading={loading}
        onCancel={() => setOpen(false)}
        onConfirm={() => {
          setOpen(false);
          onConfirm();
        }}
      />
    </>
  );
}
